import { ActionContext } from "vuex";

export interface SnackbarState {
  message?: string;
  visible: boolean;
}

export default {
  namespaced: true,
  state: (): SnackbarState => ({
    message: '',
    visible: false,
  }),
  mutations: {
    showSnackbar (state: SnackbarState, message: string) {
      state.message = message
      state.visible = true
    },
    hideSnackbar (state: SnackbarState) {
      state.message = ''
      state.visible = false
    }
  },
  getters: {
    message: (state: SnackbarState) => state.message,
    visible: (state: SnackbarState) => state.visible,
  },
  actions: {
    show (context: ActionContext<SnackbarState, {}>, message: string) {
      context.commit('showSnackbar', message)
    },
    hide (context: ActionContext<SnackbarState, {}>) {
      context.commit('hideSnackbar')
    }
  }
}
